import PropTypes from 'prop-types';
// material
import { visuallyHidden } from '@material-ui/utils';
import { Box, Checkbox, TableRow, TableCell, TableHead, TableSortLabel, Typography } from '@material-ui/core';
import { useTheme, styled, alpha } from '@material-ui/core/styles';

// ----------------------------------------------------------------------
const TableCellStyle = styled(TableCell)(({ theme }) => ({
  // height: 96,
  borderRight: "solid",
  //borderRightColor: `solid 2px ${alpha(theme.palette.primary.dark, 0.50)}`
  borderRightColor: theme.palette.mode === "light" ? "#fff" : theme.palette.grey[800],
  background: theme.palette.mode === "light" ? "#DEDEEB" : theme.palette.grey[500_16]
}))
QueueListHead.propTypes = {
  order: PropTypes.oneOf(['asc', 'desc']),
  orderBy: PropTypes.string,
  rowCount: PropTypes.number,
  headLabel: PropTypes.array,
  numSelected: PropTypes.number,
  onRequestSort: PropTypes.func,
  onSelectAllClick: PropTypes.func
};

export default function QueueListHead({
  order,
  orderBy,
  rowCount,
  headLabel,
  numSelected,
  onRequestSort,
  onSelectAllClick
}) {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  const theme = useTheme();
  return (
    <TableHead>
      <TableRow>
        {headLabel.map((headCell) => (
          <TableCellStyle
            className="br_1"
            key={headCell.id}
            align={headCell.alignRight ? 'right' : 'left'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              hideSortIcon
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              fontWeight={"bold"} sx={{ color: theme.palette.mode === "light" ? "black" : theme.palette.primary.secondary }}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box sx={{ ...visuallyHidden }}>{order === 'desc' ? 'sorted descending' : 'sorted ascending'}</Box>
              ) : null}
            </TableSortLabel>
          </TableCellStyle>
        ))}
        {/* {headLabel.map((headCell) => {
          if (headCell.is_show_table) {
            return <TableCellStyle
              className="br_1"
              key={headCell.id}
              align={headCell.alignRight ? 'right' : 'left'}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                hideSortIcon
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                <Typography sx={{ color: theme.palette.mode === "light" ? "black" : theme.palette.primary.secondary }}>  {headCell.label} </Typography>
                {orderBy === headCell.id ? (
                  <Box sx={{ ...visuallyHidden }}>{order === 'desc' ? 'sorted descending' : 'sorted ascending'}</Box>
                ) : null}
              </TableSortLabel>
            </TableCellStyle>
          }
        })} */}
      </TableRow>
    </TableHead>
  );
}
